import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

/**
 * Komponent SVG dla obszaru C - sedan widok lewy
 */
export const AreaC_Sedan_Left: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="112"
      height="153"
      viewBox="0 0 112 153"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_c_sedan_left"
          x="0"
          y="0"
          width="112"
          height="153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>

      <g filter="url(#filter_area_c_sedan_left)">
        <path
          d="M13.5521 1.72202C19.4375 1.12917 33.5048 0.183995 48.3631 0.0233715C63.3839 -0.139009 78.5927 0.516003 87.1157 2.89476C88.8244 3.37196 90.5163 3.86501 92.1315 4.33571C95.3087 5.26158 98.1895 6.1011 100.317 6.56326L100.567 6.62248C102.053 27.4074 105.816 85.627 107.99 136.974C107.839 137.025 107.68 137.086 107.517 137.158C104.441 138.521 102.141 140.638 100.561 142.093C100.186 142.438 99.8509 142.746 99.5563 142.998C98.691 143.737 98.023 144.186 97.341 144.462C96.703 144.721 95.8654 144.902 94.5935 144.804C88.2674 144.315 81.432 141.232 68.4457 134.095C65.3614 132.4 61.9573 130.494 58.1661 128.371C46.3396 121.748 30.7466 113.016 9.3467 102.009C8.84961 101.466 7.94982 100.1 7.10899 97.467C6.17889 94.5541 5.45217 90.4908 5.33589 85.2982C5.21289 79.8058 4.78028 58.9349 4.4402 39.2645C4.27015 29.4283 4.12338 19.9009 4.04997 12.7491C4.01324 9.17068 3.99504 6.20158 4.00117 4.09039C4.00259 3.60306 4.00529 3.16659 4.00926 2.78247C5.64647 2.52886 8.47428 2.23352 13.5521 1.72202Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
